import request from './request';

const userService = {
  getAll: (params) => request.get('/users', { params }),
  getID: (id) => request.get(`users/${id}`),
  delete: (id) => request.delete(`users/${id}`),
  create: (data) => request.post('users', data),
  update: (id, data) => request.patch(`users/${id}`, data),
};

export default userService;
